module.exports = __webpack_public_path__ + "static/colouring_in_petra_thumb_2-49b4758091d062c59883ea00206630bc.jpg";